function loopFiles(item, callback) {
  // item文件夹系统访问对象
  const dirReader = item.createReader(); // 返回可用于读取目录中的条目的 FileSystemDirectoryReader对象
  let fileList = [];
  function sequence() {
    dirReader.readEntries(entries => {
      // entries 文件夹里面的内容列表
      const entryList = Array.prototype.slice.apply(entries);
      fileList = fileList.concat(entryList);

      // Check if all the file has been viewed
      const isFinished = !entryList.length;

      if (isFinished) {
        callback(fileList);
      } else {
        sequence();
      }
    });
  }

  sequence();
}
// files:所有的拖拽对象组成的列表
// deepCloumNum: 过滤掉层级>=deepCloumNum的数据
const traverseFileTree = (files, treeData, isAccepted, deepCloumNum) => {
  // const treeData = {
  //   hasErrorFile: false, // 是否有不符合格式的文件
  //   hasDeepColumn: false,
  //   fileData: { column: {}, deepCloumNum: 0, hasRemoveColumn: false, columnList: [], fileList: [] },
  // };
  const _traverseFileTree = (item, path, fileData) => {
    // item：文件（或文件夹）访问系统对象
    path = path || '';
    if (item.isFile) {
      item.file(file => {
        if (isAccepted(file)) {
          if (item.fullPath && !file.webkitRelativePath) {
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: true,
              },
            });
            file.webkitRelativePath = item.fullPath.replace(/^\//, '');
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: false,
              },
            });
          }
          fileData.fileList.push(file);
        } else {
          fileData.hasErrorFile = true;
        }
      });
    } else if (item.isDirectory) {
      loopFiles(item, entries => {
        if (deepCloumNum && fileData.deepCloumNum + 1 >= deepCloumNum) {
          fileData.hasRemoveColumn = true;
          return;
        }
        const newColumn = {
          deepCloumNum: fileData.deepCloumNum + 1,
          column: item,
          fileList: [],
          columnList: [],
        };
        fileData.columnList.push(newColumn);
        if (path) {
          fileData.hasDeepColumn = true;
        }
        // 文件夹item和文件夹里面读取出来的内容entries
        entries.forEach(entryItem => {
          _traverseFileTree(entryItem, `${path}${item.name}/`, newColumn);
        });
      });
    }
  };
  for (const file of files) {
    // webkitGetAsEntry:返回文件（或文件夹）访问系统对象
    _traverseFileTree(file.webkitGetAsEntry(), '', treeData.fileData);
  }
};

export default traverseFileTree;
